import { Link } from 'react-router-dom'
import type { Project } from '@/types'

interface ProjectNavProps {
  prevProject?: Project
  nextProject?: Project
}

export default function ProjectNav({ prevProject, nextProject }: ProjectNavProps) {
  return (
    <div className="border-t border-border py-12 md:py-16">
      <div className="grid grid-cols-2 gap-4">
        {prevProject ? (
          <Link to={`/project/${prevProject.slug}`} className="text-left">
            <span className="text-label uppercase tracking-widest text-text-muted">
              &larr; Previous
            </span>
            <p className="text-h4 text-text-primary hover:text-accent transition-colors">
              {prevProject.name}
            </p>
          </Link>
        ) : (
          <div />
        )}

        {nextProject ? (
          <Link to={`/project/${nextProject.slug}`} className="text-right">
            <span className="text-label uppercase tracking-widest text-text-muted">
              Next &rarr;
            </span>
            <p className="text-h4 text-text-primary hover:text-accent transition-colors">
              {nextProject.name}
            </p>
          </Link>
        ) : (
          <div />
        )}
      </div>
    </div>
  )
}
